import { useState } from "react"
import {
	IconPlusOutline18 as Plus,
	IconTrashOutline18 as Trash,
} from "nucleo-ui-outline-18"

import { Button, IconButton, Input, Tooltip } from "@productlane/ui"

interface ExternalIdsFieldProps {
	value: string[]
	onChange: (value: string[]) => void
	isLoading?: boolean
}

export const ExternalIdsField = ({
	value,
	onChange,
	isLoading,
}: ExternalIdsFieldProps) => {
	const [addedIndex, setAddedIndex] = useState<number | null>(null)
	return (
		<div className="space-y-2">
			<div className="flex flex-row items-center justify-between text-sm font-medium">
				<div>External IDs</div>
				<Button
					variant="ghost"
					size="sm"
					Icon={Plus}
					disabled={isLoading}
					onClick={() => {
						setAddedIndex(value.length)
						onChange([...value, ""])
					}}
				>
					Add ID
				</Button>
			</div>
			{isLoading ? null : value.length === 0 ? (
				<p className="text-muted-foreground text-sm">No external IDs yet</p>
			) : (
				<div className="space-y-2">
					{value.map((externalId, index) => (
						<div key={index} className="flex items-start gap-2">
							<Input
								name="externalId"
								type="text"
								value={externalId}
								maxLength={255}
								autoFocus={index === addedIndex}
								onChange={(event) => {
									const next = [...value]
									next[index] = event.target.value
									onChange(next)
								}}
								placeholder="crm:customer:12345"
							/>
							<Tooltip label="Remove external ID" side="bottom">
								<IconButton
									variant="ghost"
									Icon={Trash}
									aria-label="Remove external ID"
									onClick={() => onChange(value.filter((_, i) => i !== index))}
								/>
							</Tooltip>
						</div>
					))}
				</div>
			)}
		</div>
	)
}
